export default __webpack_public_path__ + "static/soehne-web-halbfett-3f2bd35a7269e5e5530d706b09d7df21.woff2";